import { render, staticRenderFns } from "./Verify_bottomtbar.vue?vue&type=template&id=06a00404&scoped=true"
import script from "./Verify_bottomtbar.vue?vue&type=script&lang=js"
export * from "./Verify_bottomtbar.vue?vue&type=script&lang=js"
import style0 from "./Verify_bottomtbar.vue?vue&type=style&index=0&id=06a00404&prod&scoped=true&lang=css"
import style1 from "./Verify_bottomtbar.vue?vue&type=style&index=1&id=06a00404&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a00404",
  null
  
)

export default component.exports